export const appRoutesConfig = {
	login: {
		url: '/login',
		preauth: { path: 'preauth' as const }
	},
	home: { url: '/my-customers' }
} as const;
